import Vue from 'vue';

export default Vue.extend({
   data: function () {
       return {
           value: ''
       };
   },
   beforeMount() {
       this.value = this.params.value;
   },
    template: `<span v-if="value=='1'" style="color: #0065b3;"><i class="far fa-file-alt"/></span>`,
})